import { React, Link, StatePool, useEffect } from "../../imports/imports-packege";
import NavigationStyle from "./NavigationStyle.module.scss";
import EditContentTabs from "./EditContentTabs";
import TranslateBuilderText from '../TranslatePagesElement/translate-constructor.json';

const ActiveTabNav = StatePool.createState('app');

const Navigation = () => {
    const [activeTab, setActiveTab] = StatePool.useState(ActiveTabNav);
    const handleActiveTab = (tabName) => {
        setActiveTab(tabName);
        localStorage.setItem('activeTab', tabName);
    }
    const queryParams = new URLSearchParams(window.location.search);
    const queryString = window.location.search;

    const translateQueryParameter = queryParams.get('ln') !== 'en' && queryParams.get('ln') !== 'ua'
        ? 'en'
        : queryParams.get('ln');

    if (!queryParams.has('ln') || (queryParams.get('ln') !== 'en' && queryParams.get('ln') !== 'ua')) {
        queryParams.set('ln', translateQueryParameter);
        window.location.href = `https://${window.location.hostname}${window.location.pathname}?${queryParams.toString()}`;
    }

    useEffect(() => {
        let savedTab = localStorage.getItem('activeTab');
        let currentTab = getCurrentTabFromUrl();

        if (currentTab) {
            setActiveTab(currentTab);
            localStorage.setItem('activeTab', currentTab);
        } else if (savedTab) {
            setActiveTab(savedTab);
        }
    }, [setActiveTab]);

    const getCurrentTabFromUrl = () => {
        const path = window.location.pathname;
        if (path.startsWith("/parameters")) return "parameters";
        if (path.startsWith("/reviews")) return "review";
        return "app";
    }

    return (
        <div className={NavigationStyle.NavigationSection}>
            <div className={NavigationStyle.NavigationLinkContainer}>
                <ul className={NavigationStyle.NavigationLinkList}>
                    <li className={NavigationStyle.NavigationItemList}>
                        <Link
                            className={`${NavigationStyle.Link} ${activeTab === 'app' ? NavigationStyle.active : ''}`}
                            onClick={() => handleActiveTab('app')}
                            to={`/${queryString}`}>
                            {TranslateBuilderText[translateQueryParameter]['menu']['app-page']}
                        </Link>
                    </li>
                    <li className={NavigationStyle.NavigationItemList}>
                        <Link
                            className={`${NavigationStyle.Link} ${activeTab === 'parameters' ? NavigationStyle.active : ''}`}
                            to={`/parameters${queryString}`}
                            onClick={() => handleActiveTab('parameters')}>
                            {TranslateBuilderText[translateQueryParameter]['menu']['params-page']}
                        </Link>
                    </li>
                    <li className={NavigationStyle.NavigationItemList}>
                        <Link
                            className={`${NavigationStyle.Link} ${activeTab === 'review' ? NavigationStyle.active : ''}`}
                            to={`/reviews${queryString}`}
                            onClick={() => handleActiveTab('review')}>
                            {TranslateBuilderText[translateQueryParameter]['menu']['reviews-page']}
                        </Link>
                    </li>
                </ul>
            </div>

            <div className={NavigationStyle.TabsEditContent}>
                <EditContentTabs />
            </div>
        </div>
    );
};

export default Navigation;
